import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { Form } from 'react-final-form';

import validate from '../../../../../utils/validate';
import AgentForm from '../agent-form/AgentForm';
import { agentFormYupValidation } from '../agent-form/validation';
import FormTitle from '../../../form-title/FormTitle';
import { editSystemAgent, getAgent } from '../../../../../redux/settings/id8/id8SettingsActions';

function EditAgent() {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams();

  const editableAgent = useSelector((state) => state.id8Settings.editableAgent);

  const editAgentInitialValues = {
    name: editableAgent.name ?? '',
    instructions: editableAgent.instructions ?? '',
  };

  const handleEditAgent = async (values) => {
    await dispatch(editSystemAgent({ id, values })).then(() => {
      navigate('/settings/id8');
    });
  };

  useEffect(() => {
    dispatch(getAgent(id));
  }, [dispatch, id]);

  return (
    <>
      <FormTitle title={t('editAgent')} />

      <Form
        initialValues={editAgentInitialValues}
        onSubmit={handleEditAgent}
        validate={(values) => validate(values, agentFormYupValidation())}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => <AgentForm handleSubmit={handleSubmit} />}
      />
    </>
  );
}

export default EditAgent;
